import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import ErrorDisplay from "../../../../toolkit/errorDisplay";
import s from "./previewUnavailablePanel.scss";

interface PreviewUnavailablePanelProps {
  attemptedUrl?: string;
  onBack?: () => void;
  backText?: string;
}

const PreviewUnavailablePanel: React.FC<PreviewUnavailablePanelProps> = ({
  attemptedUrl,
  onBack,
  backText = "Back to branding setup",
}) => {
  const message = attemptedUrl
    ? `We could not load a preview of your giving site (${attemptedUrl}). The default preview site is also unavailable.`
    : "We could not load a preview of your giving site. No preview URL is configured.";

  return (
    <div className={s.panel}>
      <ErrorDisplay
        title="Preview unavailable"
        errorMessage={message}
        showRetry={false}
        showBack={!!onBack}
        onBack={onBack}
        backText={backText}
        hideSupportSection
        className={s.errorDisplay}
      />
    </div>
  );
};

export default withStyles(s)(PreviewUnavailablePanel);
